export default __webpack_public_path__ + "static/bandwidth-1-9b2ec9b6f162aa95177824263b53e573.png";